"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMarginStatusNameById = void 0;
exports.getRiskLevel = getRiskLevel;
exports.parseMarginVerificationLevels = exports.isMarginSpecificPath = void 0;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var getMarginStatusNameById = exports.getMarginStatusNameById = function getMarginStatusNameById(statusId) {
  switch (statusId) {
    case 0:
      return 'pending';
    case 1:
      return 'enabled';
    case 2:
      return 'disabled';
  }
};

/**
 * Check for margin-specific routes.
 * @param {string} path : route template path.
 */
var isMarginSpecificPath = exports.isMarginSpecificPath = function isMarginSpecificPath(path) {
  return path == '/asset-activity-details';
};
var parseMarginVerificationLevels = exports.parseMarginVerificationLevels = function parseMarginVerificationLevels() {
  var stringifiedLevels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var ranges = stringifiedLevels.split(',');
  var result = [];
  ranges.forEach(function (range) {
    if (range.includes('-')) {
      var _range$split$map = range.split('-').map(Number),
        _range$split$map2 = _slicedToArray(_range$split$map, 2),
        start = _range$split$map2[0],
        end = _range$split$map2[1];
      for (var i = start; i <= end; i++) {
        result.push(i);
      }
    } else {
      result.push(Number(range));
    }
  });
  return result;
};
function getRiskLevel(riskNumber, isMarginCall, isInLiquidation) {
  if (isInLiquidation) {
    return {
      level: 6,
      riskNumber: riskNumber,
      label: 'In Liquidation'
    };
  } else if (isMarginCall) {
    return {
      level: 5,
      riskNumber: riskNumber,
      label: 'Margin Call'
    };
  } else if (riskNumber >= 80 && riskNumber <= 100) {
    return {
      level: 4,
      riskNumber: riskNumber,
      label: 'Very High'
    };
  } else if (riskNumber >= 60 && riskNumber <= 79) {
    return {
      level: 3,
      riskNumber: riskNumber,
      label: 'High'
    };
  } else if (riskNumber >= 40 && riskNumber <= 59) {
    return {
      level: 2,
      riskNumber: riskNumber,
      label: 'Medium'
    };
  } else if (riskNumber >= 20 && riskNumber <= 39) {
    return {
      level: 1,
      riskNumber: riskNumber,
      label: 'Low'
    };
  } else if (riskNumber <= 19) {
    return {
      level: 0,
      riskNumber: riskNumber,
      label: 'Very Low'
    };
  } else {
    return {
      level: '--',
      riskNumber: riskNumber,
      label: '--'
    };
  }
}